import React from 'react';
import { Typography } from '@sm/wds-react';

const AppDetailsItem = (icon, label, link, linkLabel, search) => (
  <div className="wds-flex wds-m-b-3">
    <div className="wds-m-r-3 wds-type wds-type--light-muted">{icon}</div>
    <div className="sm-app-directory-app-details__details-link-wrapper">
      <Typography>{`${label}:`}</Typography>
      {/* The query params need to be preserved between urls (needed for ut_source) */}
      <a href={`${link}${search}`}>
        <Typography variant="link" className="sm-app-directory-app-details__details-link">
          {linkLabel}
        </Typography>
      </a>
    </div>
  </div>
);

export default AppDetailsItem;
